import "core-js/modules/es6.array.for-each";
import { useEffect as E } from "react";

var l = "mousedown",
    d = "touchstart",
    i = [l, d],
    c = function c(n, s) {
  var e = n;

  for (; e;) {
    if (e != null && e.classList && e != null && e.classList.contains(s)) return !0;
    e = e.parentElement;
  }

  return !1;
},
    m = function m(n, s, e) {
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : i;
  E(function () {
    var o = function o(t) {
      var a;
      e && c(t.target, e) || (a = n.current) != null && a.contains(t.target) || s(t);
    };

    return r.forEach(function (t) {
      document.addEventListener(t, o, {
        passive: !0
      });
    }), function () {
      r.forEach(function (t) {
        document.removeEventListener(t, o);
      });
    };
  }, [r, s, n, e]);
};

export { m as useOnClickOutside };